import Resource from './Resource';
import Moment from 'moment';

/**
 * Calendar Resource
 */
class Valuation extends Resource
{
    constructor() {
        super('vehicle.valuation', ['vehicles', 'valuations']);
    }

    value(description = {}, mileage) {
        return this._doPost([], Object.assign(description, { mileage }));
    }

    store(data = {}, params = {}) {
        return new Error('Method not implemented.');
    }

    update(id, data = {}, params = {}) {
        return new Error('Method not implemented.');
    }

    destroy(id, params = {}) {
        return new Error('Method not implemented.');
    }
}   

export let ValuationResource = new Valuation();

/**
 * Valuation Schema
 * @param {Object} defaults [description]
 */
export let ValuationSchema = function(defaults = {}) {
    let schema = {
        type: null, 
        valuation_date: null, 
        mileage: null,
        vehicle_type: null, 
        registration_date: null, 
        specification_id: null, 
        specification_driver: null, 
        manufacturer_id: null, 
        model_id: null, 
        derivative: null,
        vehicle_id: null, 
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};
